import { render, staticRenderFns } from "./OfficeClientGiata.vue?vue&type=template&id=660d9b0c&scoped=true"
import script from "./OfficeClientGiata.vue?vue&type=script&lang=js"
export * from "./OfficeClientGiata.vue?vue&type=script&lang=js"
import style0 from "./OfficeClientGiata.vue?vue&type=style&index=0&id=660d9b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660d9b0c",
  null
  
)

export default component.exports